import { ScienceProject } from '../types/interfaces'

export default [
  {
    name: 'Физика и технология стеклообразных материалов',
    description:
      'Стеклообразные материалы на основе оксидов кремния и фосфора составляют основу современной оптоэлектроники. Их уникальная аморфная структура позволяет широко изменять физико-химические свойства. В рамках своей научной деятельности я занимаюсь синтезом инновационных силикатно-фосфатных стекол и комплексным изучением их электрических и оптических свойств, что имеет решающее значение для разработки нового поколения оптических волокон и датчиков.',
    time: '2025+',
  },
  {
    name: 'Ионная проводимость в стеклокерамических композитах',
    description:
      'Стеклокерамические композиты, обладающие высокой ионной проводимомостью (Li+, Na+, K+, O2-), являются ключевым элементом революции в области хранения и преобразования энергии. Они представляют собой безопасную альтернативу жидким компонентам в твердотельных батареях нового поколения и топливных элементах. Мои исследования сосредоточены на оптимизации переноса ионов в этих структурах посредством анализа их микроструктуры и импедансных измерений.',
    time: '2025+',
  },
  {
    name: 'Моделирование ионных процессов',
    description:
      'Применение искусственного интеллекта производит революцию в современном материаловедении. Использование нейронных сетей и машинного обучения (потенциалов МО) позволяет моделировать молекулярную динамику и перенос ионов в стеклообразных материалах с квантовой точностью при минимальных вычислительных затратах. Проект включает в себя внедрение алгоритмов машинного обучения для прогнозирования структурных и диффузионных свойств стекол.',
    time: '2026+',
  },
  {
    name: 'Ускорители и ядерная аппаратура',
    description:
      'Ускорители — это устройства, используемые для ускорения частиц и излучения радиации. Они находят множество применений в промышленности и научных исследованиях, где используются, в частности, для имплантации ионов или обнаружения дефектов в материалах. Они также используются в лучевой терапии рака. Конструирование ядерной аппаратуры включает в себя как использование промышленной электроники, так и изучение таких технологий, как ионные насосы, вакуумные печи и системы гидравлического охлаждения. Во время стажировки я узнал об устройстве и возможностях ускорителей и создавал программное обеспечение для управления ими.',
    time: '2025',
    label: {
      text: 'Стажировка / Практика',
      color: '#00647D',
    },
  },
  {
    name: 'Суперионные проводники',
    description:
      'Суперионные проводники — это материалы, которые обладают высокой ионной проводимостью, что делает их перспективными для применения в батареях и топливных элементах. Во время летней мини-практики в Центре передовых материалов и технологий CEZAMAT мы изготовили образцы таких материалов, а затем изучили их свойства с помощью таких методов, как рентгеновская дифракция (XRD).',
    time: 'Лето 2024',
    label: {
      text: 'Летний проект',
      color: '',
    },
  },
  {
    name: 'Висмутовое стекло',
    description:
      'Во время летней мини-практики на физическом факультете Варшавского политехнического университета мы занимались синтезом висмутового стекла и изучали свойства материалов с кристаллической и аморфной структурами. Затем мы исследовали его электрические, тепловые и структурные свойства, уделяя особое внимание фазовым переходам, которые этот материал претерпевает под воздействием температуры, например, кристаллизации.',
    time: 'Лето 2024',
    label: {
      text: 'Летний проект',
      color: '',
    },
  },
] as ScienceProject[]
